import { render, staticRenderFns } from "./HistroyIp.vue?vue&type=template&id=57b8d340&scoped=true&"
import script from "./HistroyIp.vue?vue&type=script&lang=js&"
export * from "./HistroyIp.vue?vue&type=script&lang=js&"
import style0 from "./HistroyIp.vue?vue&type=style&index=0&id=57b8d340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8d340",
  null
  
)

export default component.exports